<script>
  import conciliacaoProjetoServico from '../servico';
  import sugerirItem from '../sugestao-item';

  const TIPOS = { 0: 'Bolsa', 1: 'Diária', 2: 'Item de compra', 3: 'Transferência', 4: 'Pagamento diverso' };

  export default {
    props: {
      linha: { type: Object, required: true },
      idContaCript: { type: String, required: true },
      natureza: { type: String, default: 'D' },
      comQuantidade: { type: Boolean, default: false },
      idLancamentoIgnorado: { type: Number, default: 0 },
      textoSugestao: { type: String, default: '' },
    },
    data() {
      return { termo: '', itens: [], carregando: true, erro: '', escolhido: this.linha.idItem || 0, timer: null, verificacoes: {}, sugestoes: [] };
    },
    computed: {
      itemEscolhido() { return this.itens.find(i => i.id === this.escolhido) || null; },
      secoes() {
        const sugeridos = this.termo ? [] : this.sugestoes.map(s => this.itens.find(i => i.id === s.id)).filter(i => !!i);
        if (sugeridos.length === 0) return [{ chave: 'todos', titulo: '', itens: this.itens }];
        return [
          { chave: 'sug', titulo: sugeridos.length === 1 ? 'Pode ser este' : 'Pode ser um destes', sugestao: true, itens: sugeridos },
          { chave: 'todos', titulo: 'Todos os itens', itens: this.itens },
        ];
      },
      valorLinha() { return +this.linha.valor || 0; },
      confere() { return this.natureza !== 'C' && this.valorLinha > 0; },
      podeEscolher() {
        const v = this.verificacoes[this.escolhido];
        return !!this.itemEscolhido && !(v && (v.carregando || v.mensagem));
      },
    },
    mounted() {
      this.carregar();
      this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
      carregar() {
        this.carregando = true;
        this.erro = '';
        conciliacaoProjetoServico
          .itensControle(this.idContaCript, this.linha.idProjeto || 0, this.linha.idRubrica || 0, this.linha.idSubRubrica || 0, this.termo, this.idLancamentoIgnorado)
          .then(resposta => {
            this.itens = (resposta && resposta.itens) || [];
            this.carregando = false;
            if (!this.termo) this.sugestoes = sugerirItem(this.itens, this.textoSugestao, i => !this.concluido(i));
            if (!this.escolhido && this.sugestoes.length === 1) this.escolhido = this.sugestoes[0].id;
            if (this.escolhido) this.verificar(this.escolhido);
          })
          .catch(res => {
            this.itens = [];
            this.carregando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível carregar os itens.';
          });
      },
      aoDigitar() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.carregar(), 300);
      },
      porQuantidade(item) { return !item.controleValorTotal && (+item.quantidade || 0) > 0; },
      concluido(item) { return (+item.dataConclusao || 0) > 0; },
      limite(item) {
        return this.porQuantidade(item) ? (+item.quantidade || 0) * (+item.valorUnitario || 0) : (+item.valorUnitario || 0);
      },
      uso(item) {
        const limite = this.limite(item);
        if (!(limite > 0)) return null;
        return Math.max(0, ((+item.valorRealizado || 0) / limite) * 100);
      },
      proporcional(item) {
        const unitario = +item.valorUnitario || 0;
        return this.porQuantidade(item) && unitario > 0 && this.valorLinha > 0 ? Math.round((this.valorLinha / unitario) * 100) / 100 : 0;
      },
      quantidadeDe(item) {
        if (this.comQuantidade && item.id === this.linha.idItem && this.linha.quantidadeManual) return +this.linha.quantidade || 1;
        return this.proporcional(item) || 1;
      },
      saldoApos(item) { return Math.round(((+item.saldo || 0) - this.valorLinha) * 100) / 100; },
      tipo(item) { return TIPOS[item.tipo] || ''; },
      motivosSugestao(item) {
        const s = this.sugestoes.find(x => x.id === item.id);
        return s ? s.motivos.join(', ') : '';
      },
      verificar(idItem) {
        if (!this.confere || this.verificacoes[idItem]) return;
        const item = this.itens.find(i => i.id === idItem);
        if (!item) return;
        const quantidade = this.quantidadeDe(item);
        this.$set(this.verificacoes, idItem, { carregando: true, mensagem: '' });
        conciliacaoProjetoServico
          .verificarItemControle(this.idContaCript, Object.assign({}, this.linha, { idItem, quantidade }), this.natureza, this.idLancamentoIgnorado)
          .then(r => this.$set(this.verificacoes, idItem, { carregando: false, mensagem: (r && r.mensagem) || '' }))
          .catch(() => this.$set(this.verificacoes, idItem, { carregando: false, mensagem: '' }));
      },
      verificacao(item) { return this.verificacoes[item.id] || null; },
      bloqueado(item) { const v = this.verificacao(item); return !!(v && v.mensagem); },
      marcar(item) {
        if (this.concluido(item)) return;
        this.escolhido = item.id;
        this.verificar(item.id);
      },
      escolher(item) {
        const alvo = item || this.itemEscolhido;
        if (!alvo || this.concluido(alvo) || this.bloqueado(alvo)) return;
        const v = this.verificacao(alvo);
        if (v && v.carregando) return;
        this.$emit('escolher', alvo);
      },
      formatar(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      formatarQuantidade(valor) {
        return (+valor || 0).toLocaleString('pt-BR', { maximumFractionDigits: 4 });
      },
    },
  }
</script>

<template>
  <div class="ice-back" @keydown.esc="$emit('fechar')">
    <div class="ice-modal" role="dialog" aria-modal="true" aria-label="Controle de item do projeto">
      <div class="ice-head">
        <div class="ice-head-ic"><i class="fa fa-cube"></i></div>
        <div class="ice-head-txt">
          <h4>Controle de item do projeto</h4>
          <div class="ice-trilha">
            <span :title="linha.nomeProjeto">{{ linha.nomeProjeto }}</span>
            <i class="fa fa-angle-right"></i>
            <span :title="linha.nomeRubrica">{{ linha.nomeRubrica }}</span>
            <i class="fa fa-angle-right"></i>
            <span :title="linha.nomeSubrubrica">{{ linha.nomeSubrubrica }}</span>
          </div>
        </div>
        <span v-if="valorLinha > 0" class="ice-valor">Esta linha <b class="mono">R$ {{ formatar(valorLinha) }}</b></span>
      </div>

      <div class="ice-busca">
        <i class="fa fa-search"></i>
        <input ref="busca" type="text" class="form-control" v-model="termo" @input="aoDigitar"
               placeholder="Código, favorecido, produto ou descrição do item...">
      </div>

      <div class="ice-corpo">
        <div v-if="carregando" class="ice-msg"><i class="fa fa-spinner fa-pulse"></i> Carregando os itens...</div>
        <div v-else-if="erro" class="ice-msg ice-msg-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="itens.length === 0" class="ice-msg">Nenhum item de controle encontrado{{ termo ? ' para "' + termo + '"' : '' }}.</div>

        <template v-for="secao in secoes" v-else>
        <div v-if="secao.titulo" :key="secao.chave + '-t'" class="ice-secao" :class="{ 'ice-secao-sug': secao.sugestao }">
          <i v-if="secao.sugestao" class="fa fa-magic"></i> {{ secao.titulo }}
          <small v-if="secao.sugestao">pelo histórico e complemento</small>
        </div>
        <button v-for="item in secao.itens" :key="secao.chave + item.id" type="button" class="ice-item"
                :class="{ 'ice-item-sel': item.id === escolhido, 'ice-item-off': concluido(item), 'ice-item-bloq': bloqueado(item), 'ice-item-sug': secao.sugestao }"
                :title="concluido(item) ? 'Item concluído: não pode ser escolhido.' : 'Duplo clique escolhe direto'"
                @click="marcar(item)" @dblclick="marcar(item); escolher(item)">
          <span class="ice-radio"><i v-if="item.id === escolhido" class="fa fa-check"></i></span>
          <span class="ice-item-corpo">
            <span class="ice-item-topo">
              <span class="ice-nome" :title="item.nome">{{ item.nome }}</span>
              <span v-if="motivosSugestao(item)" class="ice-tag ice-tag-sug" :title="'Pelo histórico e complemento: ' + motivosSugestao(item)">
                <i class="fa fa-magic"></i> {{ motivosSugestao(item) }}
              </span>
              <span v-if="concluido(item)" class="ice-tag ice-tag-off"><i class="fa fa-lock"></i> Concluído</span>
              <span v-if="tipo(item)" class="ice-tag">{{ tipo(item) }}</span>
              <span class="ice-tag" :class="porQuantidade(item) ? 'ice-tag-qtd' : 'ice-tag-valor'">
                <i class="fa" :class="porQuantidade(item) ? 'fa-sort-numeric-asc' : 'fa-money'"></i>
                {{ porQuantidade(item) ? 'Por quantidade' : 'Por valor total' }}
              </span>
            </span>
            <span class="ice-metricas">
              <span v-if="porQuantidade(item)">
                <small>Quantidade</small>
                <b class="mono">{{ formatarQuantidade(item.quantidadeRealizado) }} de {{ formatarQuantidade(item.quantidade) }}</b>
              </span>
              <span>
                <small>{{ porQuantidade(item) ? 'Valor unitário' : 'Limite' }}</small>
                <b class="mono">{{ formatar(item.valorUnitario) }}</b>
              </span>
              <span>
                <small>Realizado</small>
                <b class="mono">{{ formatar(item.valorRealizado) }}</b>
              </span>
              <span>
                <small>Saldo</small>
                <b class="mono" :class="item.saldo < 0 ? 'ice-neg' : 'ice-pos'">{{ formatar(item.saldo) }}</b>
              </span>
              <span v-if="valorLinha > 0 && porQuantidade(item)" :title="formatar(valorLinha) + ' ÷ ' + formatar(item.valorUnitario)">
                <small>Qtde desta linha</small>
                <b class="mono">{{ formatarQuantidade(quantidadeDe(item)) }}</b>
              </span>
              <span v-if="valorLinha > 0">
                <small>Saldo após esta linha</small>
                <b class="mono" :class="saldoApos(item) >= 0 ? 'ice-pos' : (bloqueado(item) ? 'ice-neg' : 'ice-alerta')">{{ formatar(saldoApos(item)) }}</b>
              </span>
            </span>
            <span v-if="verificacao(item) && verificacao(item).carregando" class="ice-aviso">
              <i class="fa fa-spinner fa-pulse"></i> Conferindo as regras do item...
            </span>
            <span v-else-if="bloqueado(item)" class="ice-aviso ice-aviso-erro">
              <i class="fa fa-ban"></i> {{ verificacao(item).mensagem }}
            </span>
            <span v-else-if="verificacao(item) && saldoApos(item) < 0" class="ice-aviso ice-aviso-alerta">
              <i class="fa fa-exclamation-triangle"></i> O saldo do item fica negativo, mas as regras da fundação aceitam este lançamento (o Desktop também aceita).
            </span>
            <span v-else-if="verificacao(item)" class="ice-aviso ice-aviso-ok">
              <i class="fa fa-check-circle"></i> Passa nas regras do item de controle.
            </span>
            <span v-if="uso(item) !== null" class="ice-uso">
              <span class="ice-uso-barra"><span :style="{ width: Math.min(100, uso(item)) + '%' }" :class="{ 'ice-uso-alto': uso(item) > 90 }"></span></span>
              <small>{{ uso(item).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) }}% usado</small>
            </span>
          </span>
        </button>
        </template>
      </div>

      <div class="ice-rodape">
        <span class="ice-cont">{{ itens.length }} {{ itens.length === 1 ? 'item' : 'itens' }}<template v-if="itens.length >= 100"> · refine a busca</template></span>
        <button type="button" class="btn btn-primary" :disabled="!podeEscolher" @click="escolher()"><i class="fa fa-check"></i> Escolher item</button>
        <button type="button" class="ice-sair" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .ice-back { position: fixed; inset: 0; background: rgba(16,24,40,.5); z-index: 3500; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .ice-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); width: 100%; max-width: 860px;
               max-height: 92vh; display: flex; flex-direction: column; overflow: hidden; }
  .ice-head { display: flex; align-items: center; gap: 14px; padding: 16px 22px; border-bottom: 1px solid #eef1f4; }
  .ice-head-ic { flex: none; width: 42px; height: 42px; border-radius: 10px; display: flex; align-items: center; justify-content: center;
                 font-size: 18px; background: #e7f4ec; color: #1e7d4f; }
  .ice-head-txt { flex: 1 1 auto; min-width: 0; }
  .ice-head-txt h4 { margin: 0 0 4px; font-size: 16px; font-weight: 600; color: #1c2024; }
  .ice-trilha { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #6b7682; min-width: 0; white-space: nowrap; overflow: hidden; }
  .ice-trilha > span { overflow: hidden; text-overflow: ellipsis; min-width: 0; }
  .ice-trilha .fa { color: #b8c0c8; }
  .ice-valor { flex: none; font-size: 12px; color: #4b5560; background: #f3f6f9; border: 1px solid #e3e8ef; border-radius: 999px; padding: 5px 12px; }
  .ice-valor b { color: #1c84c6; }
  .ice-busca { position: relative; padding: 12px 22px; border-bottom: 1px solid #eef1f4; }
  .ice-busca .fa { position: absolute; left: 33px; top: 50%; transform: translateY(-50%); color: #9aa5b1; }
  .ice-busca .form-control { height: 34px; padding-left: 30px; }
  .ice-corpo { padding: 14px 22px; overflow: auto; display: flex; flex-direction: column; gap: 8px; background: #f7f9fb; min-height: 160px; }
  .ice-msg { font-size: 12.5px; color: #6b7682; padding: 10px 0; }
  .ice-msg-erro { color: #b23b3b; }
  .ice-item { display: flex; align-items: flex-start; gap: 12px; width: 100%; text-align: left; background: #fff; border: 1px solid #e6eaee;
              border-radius: 10px; padding: 12px 14px; cursor: pointer; }
  .ice-item:hover { border-color: #a9d4b6; }
  .ice-item-sel { border-color: #1e7d4f; box-shadow: 0 0 0 3px rgba(60,154,107,.12); }
  .ice-item-off { cursor: not-allowed; opacity: .6; }
  .ice-item-off:hover { border-color: #e6eaee; }
  .ice-radio { flex: none; width: 18px; height: 18px; margin-top: 1px; border-radius: 50%; border: 1px solid #c3cbd3; background: #fff;
               display: flex; align-items: center; justify-content: center; font-size: 10px; color: #fff; }
  .ice-item-sel .ice-radio { background: #1e7d4f; border-color: #1e7d4f; }
  .ice-item-corpo { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 8px; }
  .ice-item-topo { display: flex; align-items: center; gap: 6px; min-width: 0; }
  .ice-nome { flex: 1 1 auto; min-width: 0; font-size: 13px; font-weight: 600; color: #1c2024; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .ice-tag { flex: none; display: inline-flex; align-items: center; gap: 5px; border-radius: 999px; padding: 2px 9px; font-size: 11px; font-weight: 600;
             background: #f1f3f5; color: #5b6570; border: 1px solid #e1e5e9; }
  .ice-tag-qtd { background: #e7f4ec; color: #1d6a43; border-color: #b9dfc8; }
  .ice-tag-valor { background: #e8f0fa; color: #1f4f82; border-color: #c4d7ee; }
  .ice-tag-off { background: #fdf3f3; color: #a13c3c; border-color: #e5b5b5; }
  .ice-tag-sug { background: #f3effc; color: #5b3fa6; border-color: #d8cdf3; }
  .ice-item-sug:not(.ice-item-sel) { border-color: #d8cdf3; }
  .ice-secao { display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; margin-top: 6px; font-size: 11px; font-weight: 700;
               text-transform: uppercase; letter-spacing: .05em; color: #6b7682; }
  .ice-secao:first-child { margin-top: 0; }
  .ice-secao small { font-size: 11.5px; font-weight: 500; text-transform: none; letter-spacing: 0; }
  .ice-secao-sug { color: #5b3fa6; }
  .ice-item-sug { background: #fbf9ff; }
  .ice-metricas { display: flex; flex-wrap: wrap; gap: 6px 22px; }
  .ice-metricas > span { display: flex; flex-direction: column; gap: 1px; }
  .ice-metricas small { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #8a939c; }
  .ice-metricas b { font-size: 13px; color: #34495e; }
  .ice-metricas b.ice-pos { color: #1ab394; }
  .ice-metricas b.ice-neg { color: #ED5565; }
  .ice-metricas b.ice-alerta { color: #c27c1e; }
  .ice-item-bloq { border-color: #e5b5b5; }
  .ice-item-bloq.ice-item-sel { border-color: #b23b3b; box-shadow: 0 0 0 3px rgba(178,59,59,.12); }
  .ice-item-bloq.ice-item-sel .ice-radio { background: #b23b3b; border-color: #b23b3b; }
  .ice-aviso { display: flex; align-items: flex-start; gap: 7px; font-size: 12px; line-height: 1.45; color: #6b7682;
               border-radius: 6px; padding: 6px 10px; background: #f3f6f9; }
  .ice-aviso .fa { margin-top: 2px; }
  .ice-aviso-erro { color: #a13c3c; background: #fdf3f3; }
  .ice-aviso-alerta { color: #8a5a12; background: #fdf6e9; }
  .ice-aviso-ok { color: #1d6a43; background: #f3faf6; }
  .ice-uso { display: flex; align-items: center; gap: 10px; }
  .ice-uso-barra { flex: 1 1 auto; height: 6px; border-radius: 3px; background: #edf0f3; overflow: hidden; }
  .ice-uso-barra span { display: block; height: 100%; border-radius: 3px; background: #3c9a6b; }
  .ice-uso-barra span.ice-uso-alto { background: #d08a2c; }
  .ice-uso small { flex: none; font-size: 11px; color: #6b7682; }
  .ice-rodape { display: flex; align-items: center; gap: 8px; padding: 12px 22px; border-top: 1px solid #eef1f4; }
  .ice-cont { flex: 1 1 auto; font-size: 12px; color: #8a939c; }
  .ice-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px;
              padding: 6px 18px; font-size: 12.5px; font-weight: 600; color: #a13c3c; }
  .ice-sair:hover { background: #fbe6e6; }
  @media (max-width: 680px) {
    .ice-head { flex-wrap: wrap; }
    .ice-item-topo { flex-wrap: wrap; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ItemControleEscolha.vue